import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DomSanitizer } from '@angular/platform-browser';
import { NewmemberService } from '../../services/newmember.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-imagepreview',
  templateUrl: './imagepreview.component.html',
  styleUrls: ['./imagepreview.component.css'],
  providers: [ConfirmationService]
})
export class ImagepreviewComponent implements OnInit {
  documentId: number;
  uploadedFiles: any = [];
  selectedFiles: any = [];
  deletedFiles: any = [];
  selectedSplice: any = [];
  uploadedSplice: any = [];
  items = [
    {
      label: 'Delete', icon: 'pi pi-times', command: () => {
        this.deleteFile("single");
      }
    },
    {
      label: 'Delete all', icon: 'pi pi-times', command: () => {
        this.deleteFile("all");
      }
    }
  ];
  img: any = {};
  constructor(public config: DynamicDialogConfig, public sanitizer: DomSanitizer, public nms: NewmemberService, public ref: DynamicDialogRef, public confirmationService: ConfirmationService, public msgService: MessageService) { }

  ngOnInit() {
    this.documentId = this.config.data.documentId;
    this.uploadedFiles = [];
    this.selectedFiles = this.config.data.selected;
    if (this.uploadedFiles.length != 0) {
      this.img = this.uploadedFiles[0];
    } else if (this.selectedFiles.length != 0) {
      this.img = this.selectedFiles[0];
    }

    if (this.uploadedFiles.length == 0 && this.documentId != 0) {
      this.nms.fetchFiles(this.documentId).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          for (let list of res.response.filesList) {
            let temp: any = {};
            temp.vaultId = list.vaultId;
            temp.img64 = list.file;
            temp.fileType = list.fileType;
            this.uploadedFiles.push(temp);
          }
          this.img = this.uploadedFiles[0];
        }
      }, err => {
        console.error('ERROR', err);
      });
    } 
  }

  public cancelChanges() {
    this.confirmationService.confirm({
      message: 'Are you sure the changes made will be lost?',
      accept: () => {
        this.ref.close();
      }
    });
  }

  public sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public showImg(img: any) {
    this.img = img;
  }

  public deleteFile(action: string) {
    if (action == "single") {
      for (var i = 0; i < this.selectedFiles.length; i++) {
        if (this.selectedFiles[i].url || this.selectedFiles[i].blob) {
          if ((this.selectedFiles[i].url && this.selectedFiles[i].url == this.img.url) || (this.selectedFiles[i].blob && this.selectedFiles[i].blob == this.img.blob)) { // || (this.selectedFiles[i].blob.url == this.img.blob.url)
            if (i == 0) {
              if(this.selectedFiles.length == 1) {
                this.img = this.uploadedFiles[this.uploadedFiles.length - 1];
              } else {
                this.img = this.selectedFiles[i + 1];
              }
            } else {
              this.img = this.selectedFiles[i - 1];
            }
            this.selectedFiles.splice(i, 1);
            this.selectedSplice.push(i);
            return;
          }
        }
      }
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        if (this.uploadedFiles[i].objectURL) {
          if (this.uploadedFiles[i].objectURL.changingThisBreaksApplicationSecurity == this.img.objectURL.changingThisBreaksApplicationSecurity) {
            if (i == 0) {
              if(this.uploadedFiles.length == 1) {
                this.img = this.selectedFiles[this.selectedFiles.length - 1];
              } else {
                this.img = this.uploadedFiles[i + 1];
              }
            } else {
              this.img = this.uploadedFiles[i - 1];
            }
            this.deletedFiles.push(this.uploadedFiles[i].vaultId);
            this.uploadedFiles.splice(i, 1);
            this.uploadedSplice.push(i);
          }
        } else {
          if (this.uploadedFiles[i].img64 == this.img.img64) {
            if (i == 0) {
              if(this.uploadedFiles.length == 1) {
                this.img = this.selectedFiles[this.selectedFiles.length - 1];
              } else {
                this.img = this.uploadedFiles[i + 1];
              }
            } else {
              this.img = this.uploadedFiles[i - 1];
            }
            this.deletedFiles.push(this.uploadedFiles[i].vaultId);
            this.uploadedFiles.splice(i, 1);
            this.uploadedSplice.push(i);
          }
        }

      }
    } else {
      this.selectedFiles = [];
      this.uploadedFiles = [];
    }
  }

  test(s) {
    return URL.createObjectURL(s);
  }

  saveChanges() {
    if (this.uploadedFiles.length == 0 && this.selectedFiles.length == 0) {
      if (this.documentId != 0) {
        this.nms.deleteFilebyId(this.documentId).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            this.ref.close({ "uploadedFiles": this.uploadedFiles, "selectedFiles": this.selectedFiles, 'selectedSplice': this.selectedSplice.sort().reverse(), 'uploadedSplice': this.uploadedSplice.sort().reverse() });
          } else {
            this.msgService.add({ severity: 'error', summary: 'Update Document', detail: 'Service Failed' });
          }
        }, err => {
          console.error('ERROR', err);
        });
      } else {
        this.ref.close({ "uploadedFiles": this.uploadedFiles, "selectedFiles": this.selectedFiles, 'selectedSplice': this.selectedSplice.sort().reverse(), 'uploadedSplice': this.uploadedSplice.sort().reverse() });
      }
    } else if (this.deletedFiles.length != 0) {
      this.nms.deleteFilebyId(this.documentId, this.deletedFiles).subscribe((res: any) => {
        if (res.code == "SUCCESS") {
          this.ref.close({ "uploadedFiles": this.uploadedFiles, "selectedFiles": this.selectedFiles, 'selectedSplice': this.selectedSplice.sort().reverse(), 'uploadedSplice': this.uploadedSplice.sort().reverse() });
        } else {
          this.msgService.add({ severity: 'error', summary: 'Update  Document', detail: 'Service Failed' });
        }
      }, err => {
        console.error('ERROR', err);
      });
    } else {
      this.ref.close({ "uploadedFiles": this.uploadedFiles, "selectedFiles": this.selectedFiles, 'selectedSplice': this.selectedSplice.sort().reverse(), 'uploadedSplice': this.uploadedSplice.sort().reverse() });
    }
  }

}
